import { GuiListAbfall } from "./GuiListAbfall";

export class GuiListBusinessunit extends GuiListAbfall {
}
